export const options = state => state.studiesReducer.module.costCenter.options

export const costCenter = state => state.studiesReducer.module.costCenter.costCenter

export const isLoading = state => state.studiesReducer.module.costCenter.isLoading

export const isSuccess = state => state.studiesReducer.module.costCenter.isSuccess

export const permissions = state => state.studiesReducer.module.costCenter.permissions
